import React from 'react';
import './ProfileScreen.css';

function ProfileScreen() {
  return (
    <div className='profileScreen'>
        <h1>This is ProfileScreen</h1>
    </div>
  )
}

export default ProfileScreen